import {
  DETAILS_360,
  REVYRE_DETAILS_360,
  REVYRE_WORKFLOW_DETAILS_360,
} from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Details from '.';
import DetailsThunk from './thunk';

const module: ModulesList = {
  [DETAILS_360]: {
    path: '/:module/leads/:entityId/details',
    component: Details,
    thunk: DetailsThunk,
  } as Module,

  [REVYRE_DETAILS_360]: {
    path: '/revyre/:domainType/details/:entityId',
    component: Details,
    thunk: DetailsThunk,
    props: {
      revyre: true,
    },
    breadCrumbs: {
      design: 'legacy',
      items: [
        {
          path: '#/revyre/:domainType',
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'domainName',
          },
        },
        {
          breadcrumbName: {
            routeParamKey: 'entityName',
          },
        },
      ],
    },
  } as Module,

  [REVYRE_WORKFLOW_DETAILS_360]: {
    path: '/revyre/:domainType/:workflowType/details/:entityId',
    component: Details,
    thunk: DetailsThunk,
    props: {
      revyre: true,
    },
    breadCrumbs: {
      design: 'legacy',
      items: [
        {
          path: '#/revyre/:domainType/:workflowType',
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'workflowName',
          },
        },
        {
          breadcrumbName: {
            routeParamKey: 'entityName',
          },
        },
      ],
    },
  } as Module,
};

export default module;
